import {LobbyImage} from '@colonist/types'
import {createImgIn, createParagraphIn, setElementOnClick} from '../ui_utils/DomUtils'
import {ViewPopup} from './ViewPopup'
import {TranslationObject} from '@colonist/i18n'
import {UIAPIEndpoints} from '../network/UIAPIEndpoints'
import {UIAjaxWrapper} from '../network/UIAjaxWrapper'
import {AjaxDataTypes} from '../../../../shared/AjaxDataTypes'
import {getHomepageUrlWithParameter, navigateToPage} from '../ui_utils/ClientUtils'
import {UIUrlParameterNames} from '../ui_html/UIUrlController'
import {MatchmakingMatchTypes} from '@colonist/game-base-types'
import Dice1 from '@static/images/dice_1.svg'
import Dice2 from '@static/images/dice_2.svg'
import Dice3 from '@static/images/dice_3.svg'
import Dice4 from '@static/images/dice_4.svg'
import Dice5 from '@static/images/dice_5.svg'
import Dice6 from '@static/images/dice_6.svg'
import {MINIMUM_DICE_ROLL_FOR_FREE_GAME} from '../../../../shared/matchmaking/MatchmakingUtils'

export class ViewPopupFreePlayDiceRoll extends ViewPopup {
    private readonly diceImage: HTMLImageElement
    private randomDiceInterval: NodeJS.Timeout | undefined
    private currentDiceIndex = 5

    constructor() {
        const title: TranslationObject = {key: 'strings:popups.freePlayDiceRoll.title'}
        const body: TranslationObject = {key: 'strings:popups.freePlayDiceRoll.body', options: {eligibleRolls: ViewPopupFreePlayDiceRoll.getEligibleRollsText()}}

        super(title, body, () => undefined, () => undefined, true)

        this.diceImage = createImgIn(this.body, LobbyImage.Dice6, 'dice-image')

        this.changeCheckButtonText({key: 'strings:popups.freePlayDiceRoll.checkButton'})

        setElementOnClick(this.checkButton, async() => {
            this.stopRandomDiceCycle()

            this.diceImage.classList.add('dice-rolling')

            const response = await UIAjaxWrapper.postRequestHandler(UIAPIEndpoints.apiFreePlayDiceRoll(), undefined, undefined)
            if(response == undefined) return

            const data = response.json as AjaxDataTypes.FreePlayDiceRollData
            if(data.diceRoll == undefined) return

            await this.showDiceResult(data.diceRoll)

            if(data.diceRoll >= MINIMUM_DICE_ROLL_FOR_FREE_GAME) {
                this.updateSuccess(data.diceRoll)
            } else {
                this.updateFailure(data.diceRoll)
            }
        })

        this.container.classList.add('popup-free-play-dice-roll')

        this.startRandomDiceCycle()
        this.show()
    }

    private updateSuccess(diceRoll: number) {
        createParagraphIn(this.body, {key: 'strings:popups.freePlayDiceRoll.success', options: {roll: diceRoll}}, '', '')
        this.changeCheckButtonText({key: 'strings:homePage.colonistAds.citiesAndKnightsRanked.buttonName'})
        setElementOnClick(this.checkButton, () => {
            navigateToPage(getHomepageUrlWithParameter(UIUrlParameterNames.EnterMatchmaking, MatchmakingMatchTypes.RankedCitiesAndKnights4P))
        })
    }

    private updateFailure(diceRoll: number) {
        createParagraphIn(this.body, {key: 'strings:popups.freePlayDiceRoll.failure', options: {roll: diceRoll}}, '', '')
        this.removeCheckButton()
    }

    private startRandomDiceCycle() {
        const diceImages = [Dice1, Dice2, Dice3, Dice4, Dice5, Dice6]

        this.randomDiceInterval = setInterval(() => {
            const availableIndices = [0, 1, 2, 3, 4, 5].filter((i) => i != this.currentDiceIndex)
            const randomIndex = availableIndices[Math.floor(Math.random() * availableIndices.length)]

            this.currentDiceIndex = randomIndex
            this.diceImage.src = diceImages[randomIndex]
        }, 450)
    }

    private stopRandomDiceCycle() {
        if(this.randomDiceInterval) {
            clearInterval(this.randomDiceInterval)
            this.randomDiceInterval = undefined
        }
    }

    private async showDiceResult(diceNumber: number): Promise<void> {
        return new Promise((resolve) => {
            setTimeout(() => {
                const diceImages = [Dice1, Dice2, Dice3, Dice4, Dice5, Dice6]
                this.diceImage.src = diceImages[diceNumber - 1]
            }, 600)

            setTimeout(() => {
                this.diceImage.classList.remove('dice-rolling')
                this.diceImage.classList.add('dice-reveal')

                setTimeout(() => {
                    this.diceImage.classList.remove('dice-reveal')
                    resolve()
                }, 400)
            }, 1200)
        })
    }

    private static getEligibleRollsText(): string {
        const eligibleRolls: number[] = []
        const maxRoll = 6

        for(let i = MINIMUM_DICE_ROLL_FOR_FREE_GAME; i <= maxRoll; i++) {
            eligibleRolls.push(i)
        }

        if(eligibleRolls.length == 1) return eligibleRolls[0].toString()
        if(eligibleRolls.length == 2) return eligibleRolls.join(' or ')

        eligibleRolls.pop()
        return eligibleRolls.join(', ') + `, or ${maxRoll}`
    }
}
